/** @jsxImportSource @emotion/react */
import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Config } from "./view/Config";
import { Main2 } from './view/Main2';
import { Index } from "./view/Index";
import { NotFound } from "./view/pages/NotFound";
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { LoginProvider } from './view/auth/LoginProvider';
import { ResultMessage } from "./view/pages/ResultMessage";

import { Soket } from './view/pages/Soket';

function App() {

  const theme = createTheme();

    /**  "homepage": "/static/clickeracehelpchat/frontend", */
    /** basename='/clickeracehelpchat' */  
  return (
    <>
    <ThemeProvider theme={theme}>
    <CssBaseline/>  
    <BrowserRouter basename='/product'>
      <Routes>
        <Route path='/' element={<Index></Index>}>

        </Route>
        <Route path='/config' element={
          <LoginProvider childComponent={<Config/>}></LoginProvider>
        }>
        </Route>
        <Route path='/chat' element={<Main2/>}>

        </Route>
        <Route path='/test' element={<Soket/>}>

        </Route>
        <Route path='/resultmessage' element={<ResultMessage/>}></Route>
        <Route path='*' element={<NotFound/>}>

        </Route>
      </Routes>      
    </BrowserRouter>
    </ThemeProvider>
    </>
  );
}

export default App;
